module.exports = "data:image/png;base64,UklGRhoAAABXRUJQVlA4TA4AAAAvAAAAEAcQEc0MRET/Aw=="